module.exports = __webpack_public_path__ + "411d36bb30266007b0e9bf121c528295.png";